import { ApolloClient, InMemoryCache } from '@apollo/client';
import { RestLink } from 'apollo-link-rest';

// apollo-link-rest mapea 404 a `null` (no lanza). Forzamos que se propague
// como networkError para que `useQuery.onError` reciba statusCode y la UI
// muestre el mensaje de error en vez de "no hay datos".
const throwOn404Fetch: typeof fetch = (input, init) =>
  fetch(input, init).then((res) => {
    if (res.status === 404) {
      const err = new Error(`Response not successful: Received status code 404`) as Error & { statusCode: number };
      err.statusCode = 404;
      throw err;
    }
    return res;
  });

export const apolloClient = new ApolloClient({
  link: new RestLink({
    // Default '' = same-origin (funciona en dev via CRA proxy y en prod si el
    // gateway comparte host con el front). Override con REACT_APP_API_BASE_URL
    // si el deploy separa front/back.
    uri: process.env.REACT_APP_API_BASE_URL ?? '',
    customFetch: throwOn404Fetch,
  }),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
  },
});
